import React from 'react';
import PropTypes from 'prop-types';
import Fade from '@prism/fade';
import Icon from '@prism/icon';
import classNames from 'classnames';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["className", "closeClassName", "closeAriaLabel", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "title", "innerRef"];
function useMessage(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      title = props.title,
      innerRef = props.innerRef,
      attributes = _objectWithoutProperties(props, _excluded);

  var classes = classNames(className, 'alert', 'prism-message', "prism-message--".concat(color), toggle && 'alert-dismissible');
  var closeClasses = classNames('close', closeClassName);
  var textClasses = classNames(title ? 'prism-message__text--with-title' : 'prism-message__text');

  var alertTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), transition), {}, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  var tagProps = _objectSpread2(_objectSpread2(_objectSpread2({}, attributes), alertTransition), {}, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: 'alert',
    innerRef: innerRef
  });

  return {
    tagProps: tagProps,
    closeAriaLabel: closeAriaLabel,
    closeClasses: closeClasses,
    toggle: toggle,
    title: title,
    textClasses: textClasses,
    children: children,
    color: color
  };
}

function Message(props) {
  var _useMessage = useMessage(props),
      tagProps = _useMessage.tagProps,
      closeAriaLabel = _useMessage.closeAriaLabel,
      closeClasses = _useMessage.closeClasses,
      toggle = _useMessage.toggle,
      title = _useMessage.title,
      textClasses = _useMessage.textClasses,
      children = _useMessage.children,
      color = _useMessage.color;

  function getIcon() {
    var icon;

    switch (color) {
      case 'success':
        icon = 'checkmark-circle';
        break;

      case 'danger':
      case 'warning':
        icon = 'notification-circle';
        break;

      default:
        icon = 'info';
    }

    return icon;
  }

  return /*#__PURE__*/React.createElement(Fade, tagProps, toggle ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: closeClasses,
    "aria-label": closeAriaLabel,
    onClick: toggle
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, /*#__PURE__*/React.createElement("div", {
    className: "prism-message__body"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: getIcon()
  }), title && /*#__PURE__*/React.createElement("span", {
    className: "prism-message__title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: textClasses
  }, children)));
}

Message.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  closeClassName: PropTypes.string,
  closeAriaLabel: PropTypes.string,
  color: PropTypes.string,
  fade: PropTypes.bool,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transition: PropTypes.shape(Fade.propTypes),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
};
Message.defaultProps = {
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  color: 'success',
  transition: _objectSpread2(_objectSpread2({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  }),
  children: null,
  className: '',
  closeClassName: '',
  toggle: null,
  innerRef: null
};

export { Message as default };
//# sourceMappingURL=index.js.map
